<template>
    <section class="forget-password-wrapper">
        <div class="content">
            <VerifyOtpCode :action="'login'"/>
        </div>
    </section>
  </template>
  
  <script>
  import VerifyOtpCode from "@/components/passport_account/VerifyOtpCode";

  export default {
    components: {  VerifyOtpCode  },
  };
  </script>
  
  <style lang="scss" scoped>
  .forget-password-wrapper {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      width: 500px;
      border-radius: 26px;
      background-color: #fff;
      padding: 40px 42px 40px !important;
    }
  }
  @media (max-width: 992px){
    .forget-password-wrapper{
      height: auto;
      .content{ 
        width: 390px!important;
        border-radius: 0px!important;
        padding: 40px 42px 40px !important;
      }
    } 
  }
  </style>
  